(function () {
  'use strict';

  // Modal popup (footer links)
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-humm-modal-open]');
    if (open) {
      var id = open.getAttribute('data-humm-modal-open');
      var modal = document.querySelector('[data-humm-modal-id="' + id + '"]');
      if (modal) {
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
      return;
    }
    var close = e.target.closest('[data-humm-modal-close]');
    if (close) {
      var m = close.closest('.humm-modal');
      if (m) {
        m.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.humm-modal:not([hidden])').forEach(function (m) {
        m.setAttribute('hidden', '');
      });
      document.body.style.overflow = '';
    }
  });

  // Mobile menu
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-humm-menu]');
    if (btn) {
      var panel = document.querySelector('[data-humm-mobile]');
      if (panel) {
        if (panel.hasAttribute('hidden')) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      }
      return;
    }
    var link = e.target.closest('[data-humm-mobile] a');
    if (link) {
      var p = document.querySelector('[data-humm-mobile]');
      if (p) p.setAttribute('hidden', '');
    }
  });

  // Product gallery
  document.querySelectorAll('[data-humm-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-humm-main]');
    var indexEl = gal.querySelector('[data-humm-index]');
    var thumbs = gal.querySelectorAll('[data-humm-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-humm-src');
        var i = Number(t.getAttribute('data-humm-i')) || 0;
        if (main && src) {
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = src;
            main.style.opacity = '1';
          }, 150);
        }
        if (indexEl) indexEl.textContent = String(i + 1);
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // Variant picker
  document.querySelectorAll('[data-humm-form]').forEach(function (form) {
    var script = form.querySelector('[data-humm-variants]');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }

    var input = form.querySelector('[data-humm-variant-id]');
    var current = variants.find(function (v) { return String(v.id) === String(input.value); }) || variants[0];
    var selected = current ? current.options.slice() : [];

    function update() {
      form.querySelectorAll('[data-humm-pick]').forEach(function (b) {
        var i = Number(b.getAttribute('data-humm-i'));
        var v = b.getAttribute('data-humm-v');
        b.classList.toggle('is-active', selected[i] === v);
      });
      var match = variants.find(function (v) {
        for (var i = 0; i < v.options.length; i++) {
          if (selected[i] != null && selected[i] !== v.options[i]) return false;
        }
        return true;
      });
      if (match && input) input.value = match.id;
      form.querySelectorAll('[data-humm-active]').forEach(function (el) {
        var idx = Number(el.getAttribute('data-humm-active'));
        if (selected[idx]) el.textContent = selected[idx];
      });
    }

    form.querySelectorAll('[data-humm-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.getAttribute('data-humm-i'));
        var v = b.getAttribute('data-humm-v');
        if (!Number.isNaN(i)) {
          selected[i] = v;
          update();
        }
      });
    });
    update();
  });
})();
